<template>
  <div>
    <!-- <el-table
      class="trade-pair-table"
      resizable
      border
      style="width:100%"
      :data="tradePairList"
      :row-key="() => Math.random()"
    >
      <el-table-column  fixed prop="pair" label="交易对" width="120"></el-table-column>
      <el-table-column label="交易" width="120">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="handleStatusChange(scope.row.pair, $event)"
            :value="scope.row.supportTrade"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="关闭交易对" width="120">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="handleSymbolChange(scope.row.pair, $event)"
            value="false"
          ></el-switch>
        </template>
      </el-table-column>
      
      <el-table-column prop="taker-fee" label="taker手续费" width="120"> </el-table-column>
      <el-table-column prop="maker-fee" label="maker手续费" width="120"> </el-table-column>
      <el-table-column prop="price_pric" label="交易对价格精度" width="120"> </el-table-column>
      <el-table-column prop="maker-fee" label="最小交易单位" width="120"> </el-table-column>
      <el-table-column prop="maker-fee" label="最小价格变动单位" width="140"> </el-table-column>
      <el-table-column prop="maker-fee" label="最大买单价格上浮" width="140"> </el-table-column>
      <el-table-column prop="maker-fee" label="最大买单价格下浮" width="140"> </el-table-column>
      <el-table-column prop="maker-fee" label="市价单最大吃单阈值" width="150"> </el-table-column>
      <el-table-column prop="maker-fee" label="盘口精度合并" width="120"> </el-table-column>
      <el-table-column prop="maker-fee" label="上线日期" width="120"> </el-table-column>
      <el-table-column prop="maker-fee" label="交割日期" width="120"> </el-table-column>
      <el-table-column prop="maker-fee" label="创建时间" width="120"> </el-table-column>
      <el-table-column prop="maker-fee" label="更新时间" width="120"> </el-table-column>
      <el-table-column prop="maker-fee" label="支持的订单类型" width="120"> </el-table-column>
      <el-table-column prop="maker-fee" label="支持的有效方式" width="120"> </el-table-column>
   
      <el-table-column prop="defaultPrecision" label="默认精度" width="120">
        <template slot-scope="scope">
          <a @click="handlePrecisionChange(scope.row.pair)">
            {{ scope.row.defaultPrecision }}
            <i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="amountPrecision" label="数量精度" width="120">
        <template slot-scope="scope">
          <a @click="handleAmountPrecisionChange(scope.row.pair)">
            {{ scope.row.amountPrecision }}
            <i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>
      <el-table-column label="操作"  fixed="right" width="120">
        <template slot-scope="scope">
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            size="small"
            @click="handleRemove(scope.row.pair)"
          ></el-button>
          <el-button
            type="primary"
            icon="el-icon-edit"
            circle
            size="small"
            @click="handUpdate(scope.row)"
          ></el-button>
          <el-button
            v-if="!scope.row.supportTrade"
            size="small"
            @click="handleTransaction(scope.row.pair)"
            >交易对撤单</el-button
          >
        </template>
      </el-table-column>
    </el-table> -->

    <el-table
      class="trade-pair-table"
      resizable
      border
      style="width: 100%;"
      :data="tradePairList"
      :row-key="() => Math.random()"
    >
      <el-table-column
        fixed
        prop="symbol"
        label="交易对"
        width="150"
      ></el-table-column>
      <el-table-column prop="id" label="id" width="100"></el-table-column>
      <el-table-column label="K线管理" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="repairSpotKline(scope.row)">修复K线</el-button>
        </template>
      </el-table-column>
      <el-table-column label="交易开关" width="120">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="handleStatusChange(scope.row, $event)"
            :value="scope.row.tradeSwitch"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="交易对隐藏开关" width="120">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="handleSymbolChange(scope.row, $event)"
            :value="scope.row.symbolSwitch"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="热门" width="120">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="handleHotChange(scope.row, $event)"
            :value="scope.row.hot"
          ></el-switch>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="tradeFee" label="手续费"> </el-table-column> -->
      <el-table-column prop="takerFee" label="taker手续费" width="120">
      </el-table-column>
      <el-table-column prop="makerFee" label="maker手续费" width="120">
      </el-table-column>
      <el-table-column prop="pricePrecision" label="交易对价格精度" width="120">
      </el-table-column>
      <el-table-column
        prop="quantityPrecision"
        label="交易对数量精度"
        width="120"
      >
      </el-table-column>
      <el-table-column prop="minQty" label="最小交易单位" width="120">
      </el-table-column>
      <el-table-column prop="minStepPrice" label="最小价格变动单位" width="140">
      </el-table-column>
      <el-table-column prop="multiplierUp" label="最大买单价格上浮" width="140">
      </el-table-column>
      <el-table-column
        prop="multiplierDown"
        label="最大买单价格下浮"
        width="140"
      >
      </el-table-column>
      <el-table-column
        prop="marketTakeBound"
        label="市价单最大吃单阈值"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="depthPrecisionMerge"
        label="盘口精度合并"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="onboardDate"
        label="上线日期"
        width="120"
      >
       <template slot-scope="scope">
 {{scope.row.onboardDate?timestampToTime(scope.row.onboardDate):'--'}}
       </template>
     
      </el-table-column>
      <el-table-column prop="sequence" label="sequence" width="120">
      </el-table-column>
      <!-- <el-table-column prop="deliveryTime" label="交割日期" width="120"> </el-table-column> -->
      <!-- <el-table-column prop="createdTime" label="创建时间" width="120"> </el-table-column> -->
      <!-- <el-table-column prop="updatedTime" label="更新时间" width="120"> </el-table-column> -->
      <el-table-column
        prop="supportOrderType"
        label="支持的订单类型"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="supportTimeInForce"
        label="支持的有效方式"
        width="120"
      >
      </el-table-column>
      <!-- <el-table-column prop="supportEntrustType" label="支持的计划委托类型" width="120"> </el-table-column> -->

      <!--  -------------------     old   ------------------- -->
      <!-- <el-table-column prop="defaultPrecision" label="默认精度" width="120">
        <template slot-scope="scope">
          <a @click="handlePrecisionChange(scope.row.pair)">
            {{ scope.row.defaultPrecision }}
            <i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="amountPrecision" label="数量精度" width="120">
        <template slot-scope="scope">
          <a @click="handleAmountPrecisionChange(scope.row.pair)">
            {{ scope.row.amountPrecision }}
            <i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" fixed="right" width="320" align="center">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="small"
            @click="handRepair(scope.row)"
          >k线更新</el-button>
          <!-- <el-tooltip  class="item" effect="dark" content="交易对下架" placement="left">
            <el-button
            type="danger"
            icon="el-icon-back"
            circle
            size="small"
            :disabled="scope.row.state!==2"
            @click="handleRemove(scope.row)"
          ></el-button>
          </el-tooltip> -->
          
          <el-button
            type="primary"
            icon="el-icon-edit"
            circle
            size="small"
            @click="handUpdate(scope.row)"
          ></el-button>
          <el-button
            v-if="!scope.row.supportTrade"
            size="small"
            style="margin-top: 5px"
            @click="handleTransaction(scope.row.symbol)"
            >交易对撤单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handlePageChanged($event)"
    ></pagination>
    <el-dialog
      title="K线更新"
      :visible.sync="klineDialogVisible"
      width="560px"
      :close-on-click-modal="false"
      :close-on-press-escape="!klineUpdating"
      :show-close="!klineUpdating"
      @closed="resetKlineDialog"
    >
      <div class="kline-update-tip">
        交易对：{{ klineUpdatingSymbol ? klineUpdatingSymbol.symbol : "--" }}。提交后只会删除并重新导入选中的K线周期，其他周期不受影响。
      </div>
      <el-checkbox
        v-model="klineTypeCheckAll"
        :indeterminate="klineTypeIndeterminate"
        @change="handleKlineTypeCheckAllChange"
      >全选</el-checkbox>
      <el-checkbox-group
        v-model="selectedKlineTypes"
        class="kline-type-group"
        @change="handleKlineTypeChange"
      >
        <el-checkbox
          v-for="item in klineTypeOptions"
          :key="item.value"
          :label="item.value"
        >{{ item.label }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="klineUpdating" @click="klineDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="klineUpdating" @click="submitKlineUpdate">确定更新</el-button>
      </span>
    </el-dialog>
    <update-list
      :val1="chooseOne"
      @refresh="refreshList"
      :pagination="pagination2"
      :buyCoin="area"
      :state="state"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";
import SortableMixin from "mixins/SortableMixin";
import updateList from "../update";
import { Row } from "element-ui";

export default {
  name: "TradePairList",
  mixins: [SortableMixin],
  components: {
    Pagination,
    updateList,
  },
  props: ["area",'state'],
  data() {
    return {
      sortable: ".trade-pair-table",
      pagination2:{},
      currentData: {
        price: "",
        amount: -1,
      },
      chooseOne: {},
      klineDialogVisible: false,
      klineUpdating: false,
      klineUpdatingSymbol: null,
      selectedKlineTypes: [],
      klineTypeCheckAll: false,
      klineTypeIndeterminate: false,
      klineTypeOptions: [
        { value: "1s", label: "1秒" },
        { value: "1m", label: "1分钟" },
        { value: "3m", label: "3分钟" },
        { value: "5m", label: "5分钟" },
        { value: "15m", label: "15分钟" },
        { value: "30m", label: "30分钟" },
        { value: "1h", label: "1小时" },
        { value: "2h", label: "2小时" },
        { value: "4h", label: "4小时" },
        { value: "6h", label: "6小时" },
        { value: "8h", label: "8小时" },
        { value: "12h", label: "12小时" },
        { value: "1d", label: "1日" },
        { value: "1w", label: "1周" },
        { value: "1M", label: "1月" },
      ],
    };
  },
  computed: {
    ...mapGetters("tradePairSetting", ["tradePairList"]),
    ...mapState("tradePairSetting", ["pagination", "totalCount"]),
  },
  methods: {
    repairSpotKline(row) {
      this.$router.push({
        path: "/home/setting/spotKlineRepair",
        query: { symbolId: row.id },
      });
    },
    ...mapActions("tradePairSetting", [
      "updateTradeStatus",
      "remove",
      "transaction",
      "updateDefaultPrecision",
      "updateAmountPrecision",
      "updateSort",
      "list",
      "tradeSwitch",
      "symbolSwitch",
      'getAllSymbol','hotSwitch','delSymbol','delKlineData','getKlineData'
    ]),
    ...mapMutations("tradePairSetting", ["setUpdaterDialog"]),
    refreshList(data = {}) {
      this.getAllSymbol({
      
        ...data,
      });
    },
    timestampToTime(timestamp){
      var date = new Date(timestamp );//时间戳为10位需*1000，时间戳为13位的话不需乘1000

        let  Y = date.getFullYear() + '-';

        let   M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';

        let   D = date.getDate() + ' ';

        let   h = date.getHours() + ':';

        let   m = date.getMinutes() + ':';

        let   s = date.getSeconds();

          return Y+M+D+h+m+s;
    },
    // 打开K线周期选择窗口，避免一次更新误删所有周期。
    handRepair(row){
      this.klineUpdatingSymbol = row;
      this.selectedKlineTypes = [];
      this.klineTypeCheckAll = false;
      this.klineTypeIndeterminate = false;
      this.klineDialogVisible = true;
    },
    handleKlineTypeCheckAllChange(checked) {
      this.selectedKlineTypes = checked
        ? this.klineTypeOptions.map(item => item.value)
        : [];
      this.klineTypeIndeterminate = false;
    },
    handleKlineTypeChange(types) {
      const checkedCount = types.length;
      this.klineTypeCheckAll = checkedCount === this.klineTypeOptions.length;
      this.klineTypeIndeterminate = checkedCount > 0 && checkedCount < this.klineTypeOptions.length;
    },
    resetKlineDialog() {
      this.klineUpdatingSymbol = null;
      this.selectedKlineTypes = [];
      this.klineTypeCheckAll = false;
      this.klineTypeIndeterminate = false;
    },
    submitKlineUpdate() {
      if (!this.selectedKlineTypes.length) {
        this.$message.warning("请至少选择一个K线周期");
        return;
      }
      if (!this.klineUpdatingSymbol) {
        return;
      }
      this.klineUpdating = true;
      this.getKlineData({
          symbolId: this.klineUpdatingSymbol.id,
          types: [...this.selectedKlineTypes],
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success("K线更新任务已提交");
            this.klineDialogVisible = false;
          }
        })
        .finally(() => {
          this.klineUpdating = false;
        });
    },
    handleSetPrice({ pair, status }) {
      const h = this.$createElement;
      const self = this;
      this.$msgbox({
        title: "设置",
        message: h("p", null, [
          h("input", {
            class: { "el-input__inner": true },
            style: {
              marginBottom: "10px",
            },
            domProps: {
              value: self.value,
              placeholder: "开盘价格",
            },
            on: {
              input: function (event) {
                self.currentData.price = event.target.value;
              },
            },
          }),
          h("input", {
            class: { "el-input__inner": true },
            domProps: {
              value: self.value,
              placeholder: "开盘数量",
            },
            on: {
              input: function (event) {
                self.currentData.amount = event.target.value;
              },
            },
          }),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "执行中...";
            setTimeout(() => {
              done();
              setTimeout(() => {
                instance.confirmButtonLoading = false;
              }, 300);
            }, 3000);
          } else {
            done();
          }
        },
      }).then(() => {
        this.doUpdateStatus({ pair, status });
      });
    },
    handleSymbolChange(row, status) {

      const message = `确认要${status ? "开启" : "关闭"}交易对隐藏吗？`;

      this.$confirm(message, "提示", { type: "warning " }).then(() => {
        this.symbolSwitch({ id: row.id, type: status }).then((res) => {
          
          if (res.code == 0) {
            this.$message.success("修改成功");
            this.$emit("refresh");
          }
        });
      });
    },
    handleHotChange(row,status){
      const message = `确认要${status ? "开启" : "关闭"}热门功能吗？`;
      this.$confirm(message, "提示", { type: "warning " }).then(() => {
        this.hotSwitch({ id: row.id, hot: status }).then((res) => {
          if (res.code == 0) {
            this.$message.success("修改成功");
            this.$emit("refresh");
          }
        });
      });
    },
    handleStatusChange(pair, status) {
      this.currentData.amount = -1;
      this.currentData.price = "";
      const message = `确认要${status ? "开启" : "关闭"}交易功能吗？`;

      this.$confirm(message, "提示", { type: "warning " }).then(async () => {
        //   if (status) {
        //     this.$confirm('是否设置开盘价格', '提示', {
        //       type: 'warning ',
        //       confirmButtonText: '设置开盘价',
        //       cancelButtonText: '直接开启'
        //     })
        //       .then(() => {
        //         Promise.resolve().then(() => {
        //           this.handleSetPrice({ pair, status });
        //         });
        //       })
        //       .catch(() => {
        //         this.doUpdateStatus({ pair, status });
        //       });
        //   } else {
        //     this.doUpdateStatus({ pair, status });
        //   }
        const res = await this.tradeSwitch({ id: pair.id, type: status });
        if (res.code == 0) {
          this.$message.success("修改成功");
          this.$emit("refresh");
        }
      });
    },
    doUpdateStatus({ pair, status }) {
      this.updateTradeStatus({
        pair,
        status,
        amount: this.currentData.amount,
        price: this.currentData.price,
      })
        .then(() => {
          this.$message.success("操作成功！");
          this.$emit("refresh");
        })
        .finally(() => {
          this.currentData.amount = -1;
          this.currentData.price = "";
        });
    },
    //下架交易对 
    handleRemove(row) {
      let id=row.id
      this.$confirm("确认要下架该交易对吗？", "提示", { type: "warning" }).then(
        async () => {
        const res=await this.delSymbol(id)
            if(res.code==0){
                this.$message.success("成功下架该交易对！");
            this.$emit("refresh");
            }
          
          });
    },
    handleTransaction(pair) {
      console.log('pair',pair);
      this.$confirm("确认要撤销该交易对下的所有订单么？", "提示", {
        type: "warning",
      }).then(() => {
        this.transaction(pair).then(() => {
          this.$message.success("撤单成功！");
          this.$emit("refresh");
        });
      });
    },
    handlePageChanged(pagination) {
    // console.log(pagination);
      this.pagination2={...pagination}
      // console.log('pagess',this.pagination2);
      this.$emit("refresh", pagination);
    },
    handlePrecisionChange(pair) {
      this.$prompt("请输入默认精度", "提示", {
        inputValidator: (value) => {
          return !value || !value.trim() ? "请输入默认精度" : true;
        },
      }).then(({ value }) => {
        this.updateDefaultPrecision({ pair, precision: Number(value) }).then(
          () => {
            this.$message.success("操作成功！");
            this.$emit("refresh");
          }
        );
      });
    },
    handleAmountPrecisionChange(pair) {
      this.$prompt("请输入数量精度", "提示", {
        inputValidator: (value) => {
          return !value || !value.trim() ? "请输入数量精度" : true;
        },
      }).then(({ value }) => {
        this.updateAmountPrecision({ pair, precision: Number(value) }).then(
          () => {
            this.$message.success("操作成功！");
            this.$emit("refresh");
          }
        );
      });
    },
    handUpdate(item) {
      this.chooseOne = {...item,supportOrderType:item.supportOrderType.split('').filter(e=>e!=',')};
      console.log('item.supportOrderType',item.supportOrderType.split('').filter(e=>e!=','));
      this.setUpdaterDialog(true);
    },
    onSort(evt) {
      const { oldIndex, newIndex } = evt;
      const { page, size } = this.pagination;

      if (oldIndex !== newIndex) {
        const pair = this.tradePairList[oldIndex].pair;

        this.updateSort({
          pair,
          orderNo: (page - 1) * size + newIndex + 1,
        }).then(() => {
          this.$message.success("更新成功！");
          this.$emit("refresh");
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.kline-update-tip {
  margin-bottom: 16px;
  line-height: 22px;
  color: #e6a23c;
}

.kline-type-group {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px 0;
  margin-top: 16px;
}

.kline-type-group .el-checkbox {
  margin-left: 0;
  margin-right: 12px;
}
</style>
